export const errors = {
  first_column_doesnt_have_numbers:
    'Первая строка файла не содержит номер, либо файл содержит заголовки столбцов.',
  illegal_symbol_in_number: 'Файл содержит пустую строку или неверный формат номера.',
  number_must_contain_min_max_digits:
    'Номер телефона должен содержать не менее 5 и не более 18 цифр.',
  too_many_rows: 'Превышено допустимое количество строк в файле.',
  row: ' (Строка {row})',
  not_found: 'не найдено',
  field: 'Поле',
  rule: {
    check_import_file_extension: 'Расширение файла может быть csv, xls, xlsx',
    required: 'Поле обязательное',
    file: 'Поле должно содержать файл',
    array: 'Поле должно быть массивом',
    maxarray: 'Превышено количество записей',
    string: 'Поле должно быть строкой',
    integer: 'Поле должно быть целым числом',
    maxnumeric: 'Значение слишком большое',
    minnumeric: 'Значение слишком маленькое',
    maxstring: 'Значение слишком длинное',
    minstring: 'Значение слишком короткое',
    regex: 'Неверный формат',
    date_format: 'Неверный формат даты'
  },
  recaptcha: 'Ошибка reCAPTCHA',
  general_not_success_request: 'Запрос не может быть выполнен',
  captcha_bad_request: 'Запрос не может быть выполнен. Обратитесь в службу поддержки'
};
